import { makeStyles } from '@mui/styles';
import { Colors } from '../../../../../assets/styles';

const useStyles = makeStyles(() => ({
  name: {
    color: Colors.Blue1,
    display: 'block',
  },
  email: {
    fontSize: 13,
  },
  lastCell: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  date: {
    fontSize: '13px !important',
    width: '100%',
  },
  status: {
    borderRadius: 14.5,
    backgroundColor: Colors.Green3,
    width: 123,
    padding: '5px 0',
  },
  pendingStatus: {
    backgroundColor: Colors.Orange,
    '& $statusText': {
      color: Colors.White,
    },
  },
  submittedStatus: {
    backgroundColor: Colors.Red,
    '& $statusText': {
      color: Colors.White,
    },
    marginRight: '15.9%',
  },
  finishedStatus: {
    backgroundColor: Colors.Green3,
    '& $statusText': {
      color: Colors.White,
    },
  },
  statusText: {
    fontSize: '13px !important',
    color: Colors.White,
    textAlign: 'center',
  },
}));

export default useStyles;